import type { DisplayCurrencyIso } from '@/shared/types/displayCurrency';

export function normalizeDisplayCurrencyIso(iso: DisplayCurrencyIso): string | null {
  if (!iso) {
    return null;
  }

  return iso.toUpperCase();
}
